<template>
    <div>
        <template v-if="viewPage == true">
            <div class="modal fade" id="batchSummary" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body batchSummary-payment-popup text-left p-4">
                            <div class="popup-head line-head">
                                <h2 class="pb-2"> Batch Summary </h2>
                            </div>
                            <div class="row normal-ib-space mt-3">
                                <div class="col-md-12 mb-3">
                                    <h3>Batch is uploaded and under processing click proceed to continue</h3>
                                    <!-- <table width="100%" v-if="batchSummary != null">
                                        <tr>
                                            <td> New records inserted </td>
                                            <td> {{batchSummary.inserted}} </td>
                                        </tr>
                                        <tr>
                                            <td> Existing records updated </td>
                                            <td> {{batchSummary.updated}} </td>
                                        </tr>
                                        <tr>
                                            <td> Discrepant records </td>
                                            <td> {{batchSummary.discrepants}} </td>
                                        </tr>
                                    </table> -->
                                </div>
                                <div class="col pull-right">
                                    <button class="btn btn-primary" v-on:click="proceedToVendors"> Proceed </button>
                                    <button class="btn btn-primary" v-if="unregisterWallet.length > 0" v-on:click="csvExport"> Download Discrepants</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Login Modal End-->

            <div class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addDepartment" tabindex="-1" aria-labelledby="addDepartment" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Department  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="departmentForm.name" class="form-control" name="name" id="departmentAddValue" :class="{ 'is-invalid': departmentForm.errors.has('name') }"/>
                                <has-error :form="departmentForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveDepartment()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCategory" tabindex="-1" aria-labelledby="addCategory" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Category  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="categoryForm.name" class="form-control" name="name" id="categoryAddValue" :class="{ 'is-invalid': categoryForm.errors.has('name') }"/>
                                <has-error :form="categoryForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCategory()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCity" tabindex="-1" aria-labelledby="addCity" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add City  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="cityForm.name" class="form-control" name="name" id="cityAddValue" :class="{ 'is-invalid': cityForm.errors.has('name') }"/>
                                <has-error :form="cityForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCity()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addBranch" tabindex="-1" aria-labelledby="addBranch" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Branch  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="branchForm.name" class="form-control" name="name" id="branchAddValue" :class="{ 'is-invalid': branchForm.errors.has('name') }"/>
                                <has-error :form="branchForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveBranch()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Vendor Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/vendors"> Cancel </router-link>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p v-show="$global.user_company_payment_engine != 'FAYSAL'">Download a bank code template <a :href="`${$global.base_url}csv/BankCode`" target="_blank">here.</a> </p>
                            <p>Download a sample template <a :href="`${$global.base_url}csv/VendorBulk`" target="_blank">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must meet the
                            following requirements in
                            order to upload employees
                            in Bulk: <br/>
							1. Mandatory fields : Mobile Number, Bank Code, Account Number,cnic<br/>
							2. Only add registered account numbers.<br/>
							3. Mobile numbers must be in the following format: 923XXXXXXXXX.<br/>
							4. Set the formatting of mobile number column to “Number” with zero decimal places.<br/>
							5. No repetition of column names.<br/>
							6. No empty cells in a valid row.<br/>
							7. No special characters in the sheet.</p>">

                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="”Mandatory Information” contain fields that are required for Finja Business to process your sheet."></i> </label>
                                    <div class="mandatory-tags">
                                        <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobile_number" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Bank Code"> <i v-show="mand_bank_code" class="fas fa-check"></i> Bank Code </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Account Number"> <i v-show="mand_account_number" class="fas fa-check"></i> Account Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Account Type"> <i v-show="mand_account_type" class="fas fa-check"></i> Account Type </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Default"> <i v-show="mand_default" class="fas fa-check"></i> Default </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="viewPage == null">
            <div class="inside-loader">
                <div class="inside-loader-inner">
                    <img src="/images/payroll.png" alt="" />
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        </template>
        <template v-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                unregisterWallet:{},
                cityForm: new Form({
                    name : '',
                }),
                departmentForm: new Form({
                    name : '',
                }),
                categoryForm: new Form({
                    name : '',
                }),
                branchForm: new Form({
                    name : '',
                }),
                viewPage : true,
                previewMapField : false,
                mand_name : false,
                mand_father_name : false,
                mand_email : false,
                mand_mobile_number : false,
                mand_account_type : false,
                mand_bank_code : false,
                mand_account_number : false,
                mand_dob : false,
                mand_doj : false,
                mand_description : false,
                mand_department : false,
                mand_branch : false,
                mand_city : false,
                mand_category : false,
                mand_address : false,
                mand_tax : false,
                mand_filer : false,
                mand_ntn : false,
                mand_default : false,
                // default : false,
                fileAdded : false,
                filecolumn : [],
                fileRowData : [],
                departmentCount : 0,
                departmentMapped : 0,
                branchCount : 0,
                branchMapped : 0,
                cityCount : 0,
                cityMapped : 0,
                categoryCount : 0,
                categoryMapped : 0,
                departmentLi : [],
                branchLi : [],
                cityLi :[],
                categoryLi : [],
                finalDepartmentArray : [],
                finalcategoryArray : [],
                finalcityArray : [],
                finalBranchArray : [],
                dropZoneObject : null,
                proceedButtonflag : false,
                batchSummary : null,
            }
        },
        methods: {
            csvExport() {
                let that = this;
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    [
                        'Name',
                        'Father Name',
                        'Email',
                        'CNIC',
                        'Mobile Number',
                        'Account Type',
                        'Account Number',
                        'Bank Code',
                        'Date of birth',
                        'Date of Joining',
                        'Description',
                        'Department',
                        'Branch',
                        'City',
                        'Category',
                        'Current Address',
                        'Tax Filer',
                        'NTN'
                    ],
                    ...that.unregisterWallet.map(item => item)
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "Descrepant Records.csv");
                link.click();
            },

            proceedToVendors(){
                $('#batchSummary').modal('hide');
                this.$router.push('/vendors');
            },
            processDropzoneQueue(){

            },
            getBulkUploadData(){
                var that = this;
                this.$Progress.start();
                axios.get('/api/getVendorBulkUploadData')
                    .then(res => {
                        if(res.status == 200){
                            res.data.departments.forEach(dept => {
                            that.departmentLi.push({value:dept.id,label:dept.name});
                            });
                            res.data.branches.forEach(branch => {
                            that.branchLi.push({value:branch.id,label:branch.name});
                            });
                            res.data.cities.forEach(city => {
                            that.cityLi.push({value:city.id,label:city.name});
                            });
                            res.data.categories.forEach(category => {
                            that.categoryLi.push({value:category.id,label:category.name});
                            });
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                    });
            },
            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    timeout:0,
                    url: that.$global.base_url+'api/vendorBulkUpload',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            var ext = file.name.split('.')[1];
                            var invalid = 0;
                            if(ext != 'csv'){
                                that.showToastBox('error','Invalid file added');
                                this.removeFile(file);
                                return false;
                            }
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            that.$Progress.start();
                            $('div.progress').addClass('step-three').removeClass('step-two');
                            if(
                                (that.departmentCount > 0 && that.departmentCount != that.departmentMapped) ||
                                (that.categoryCount > 0 && that.categoryCount != that.categoryMapped) ||
                                (that.cityCount > 0 && that.cityCount != that.cityMapped) ||
                                (that.branchCount > 0 && that.branchCount != that.branchMapped)
                            ){
                                if($("#needAttention").hasClass('show')){
                                    that.showAlertBox('error','Please either add them or associate them with exisiting ones.');
                                }else{
                                    $("#needAttention").modal("show");
                                }
                                that.$Progress.finish();
                            }else{
                                that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                            }
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var departmentNames = [];
                            var departmentids = [];

                            var categoryNames = [];
                            var categoryids = [];

                            var cityNames = [];
                            var cityids = [];

                            var branchNames = [];
                            var branchids = [];

                            that.finalDepartmentArray.forEach(dept => {
                                departmentNames.push(dept.name);
                                departmentids.push(dept.id);
                            });

                             that.finalcategoryArray.forEach(cat => {
                                categoryNames.push(cat.name);
                                categoryids.push(cat.id);
                            });

                             that.finalcityArray.forEach(city => {
                                cityNames.push(city.name);
                                cityids.push(city.id);
                            });

                             that.finalBranchArray.forEach(branch => {
                                branchNames.push(branch.name);
                                branchids.push(branch.id);
                            });
                            // Will send the filesize along with the file as POST data.
                            formData.append("departmentNames", JSON.stringify(departmentNames));
                            formData.append("departmentids", JSON.stringify(departmentids));
                            formData.append("categoryNames", JSON.stringify(categoryNames));
                            formData.append("categoryids", JSON.stringify(categoryids));
                            formData.append("cityNames", JSON.stringify(cityNames));
                            formData.append("cityids", JSON.stringify(cityids));
                            formData.append("branchNames", JSON.stringify(branchNames));
                            formData.append("branchids", JSON.stringify(branchids));
                            formData.append("filesize", file.size);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            console.log('in')
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            var msg = null;
                            if(obj.code == "200") {
                                //that.showToastBox('success','Vendors uploaded successfully');
                                if($("#needAttention").hasClass('show')){
                                    $("#needAttention").modal("hide");
                                }
                                that.$Progress.finish();
                                that.batchSummary = obj.data;
                                that.unregisterWallet = obj.data.unregisterWalletBulkUpload;
                                $('#batchSummary').modal('show');
                                //that.$router.push('/vendors');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });

                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                this.fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            if(401 == xhr.status){
                                swal.fire({
                                    title: "Session Expired",
                                    text: "Your session has expired. Would you like to be redirected to the login page?",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Yes",
                                    closeOnConfirm: false
                                }).then((result) => {
                                    if (result.value) {
                                        window.location = '/login';
                                    }
                                });
                            }else{
                                var msg = '<strong>Error:'+xhr.status+'</strong> '+xhr.statusText;
                                that.showAlertBox('error','Error in file', msg);
                            }
                            file.status = Dropzone.QUEUED;
                        });
                    }


                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var deptRowid = 0;
                var categoryRowid = 0;
                var cityRowid = 0;
                var branchRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            if(data[row] != ""){
                                for(var item in data[row]){
                                    var value = data[row][item];
                                    _row.push(value);
                                }
                                that.fileRowData.push(_row);
                            }
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'father name'){
                            that.mand_father_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'email'){
                            that.mand_email = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobile_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account type'){
                            that.mand_account_type = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'bank code'){
                            that.mand_bank_code = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account number'){
                            that.mand_account_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'date of birth'){
                            that.mand_dob = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'date of joining'){
                            that.mand_doj = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'description'){
                            that.mand_description = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'department'){
                            that.mand_department = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'branch'){
                            that.mand_branch = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'city'){
                            that.mand_city = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'category'){
                            that.mand_category = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'address'){
                            that.mand_address = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'tax'){
                            that.mand_tax = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'filer'){
                            that.mand_filer = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'ntn'){
                            that.mand_ntn = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'default'){
                            that.mand_default = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Vendor Detail">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'father name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'father name') ? true : fieldMap;
                        comboBox += '<option value="Father Name" '+selected+'>Father Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email') ? true : fieldMap;
                        comboBox += '<option value="Email" '+selected+'>Email</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic') ? true : fieldMap;
                        comboBox += '<option value="CNIC" '+selected+'>CNIC</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="Mobile Number" '+selected+'>Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account type') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account type') ? true : fieldMap;
                        comboBox += '<option value="Account Type" '+selected+'>Account Type</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'bank code') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'bank code') ? true : fieldMap;
                        comboBox += '<option value="Bank Code" '+selected+'>Bank Code</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account number') ? true : fieldMap;
                        comboBox += '<option value="Account Number" '+selected+'>Account Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'date of birth') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'date of birth') ? true : fieldMap;
                        comboBox += '<option value="Date of Birth" '+selected+'>Date of Birth</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? true : fieldMap;
                        comboBox += '<option value="Date of Joining" '+selected+'>Date of Joining</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'description') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'description') ? true : fieldMap;
                        comboBox += '<option value="description" '+selected+'>Description</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'department') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'department') ? true : fieldMap;
                        comboBox += '<option value="Department" '+selected+'>Department</option>';
                        if(selected == 'selected'){
                            deptRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'branch') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'branch') ? true : fieldMap;
                        comboBox += '<option value="Branch" '+selected+'>Branch</option>';
                        if(selected == 'selected'){
                            branchRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'city') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'city') ? true : fieldMap;
                        comboBox += '<option value="City" '+selected+'>City</option>';
                        if(selected == 'selected'){
                            cityRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'category') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'category') ? true : fieldMap;
                        comboBox += '<option value="Category" '+selected+'>Category</option>';
                        if(selected == 'selected'){
                            categoryRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'current address') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'current address') ? true : fieldMap;
                        comboBox += '<option value="Current Address" '+selected+'>Address</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'tax') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'tax') ? true : fieldMap;
                        comboBox += '<option value="Tax" '+selected+'>Tax</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'tax filer') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'tax filer') ? true : fieldMap;
                        comboBox += '<option value="Tax Filer" '+selected+'>Tax Filer</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'ntn') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'ntn') ? true : fieldMap;
                        comboBox += '<option value="NTN" '+selected+'>NTN</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'default') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'default') ? true : fieldMap;
                        comboBox += '<option value="Default" '+selected+'>Default</option>';
                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    if(deptRowid != 0){
                        that.showFieldInIdentifiers('department',that.fileRowData,deptRowid);
                    }
                    if(categoryRowid != 0){
                        that.showFieldInIdentifiers('category',that.fileRowData,categoryRowid);
                    }
                    if(cityRowid != 0){
                        that.showFieldInIdentifiers('city',that.fileRowData,cityRowid);
                    }
                    if(branchRowid != 0){
                        that.showFieldInIdentifiers('branch',that.fileRowData,branchRowid);
                    }
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                if(this.mand_mobile_number == true  && this.mand_bank_code == true && this.mand_account_number == true && this.mand_default == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_mobile_number = this.mand_bank_code = this.mand_account_number = false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'mobile number') this.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'bank code') this.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') this.mand_account_number = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    //hide the department, branch and city field sets if deselect
                    if(previous.toLowerCase() == 'department'){
                        $('div.departmentTable').remove();
                        $('table.departmentTable').remove();
                    }
                    if(previous.toLowerCase() == 'category'){
                        $('div.categoryTable').remove();
                        $('table.categoryTable').remove();
                    }
                    if(previous.toLowerCase() == 'city'){
                        $('div.cityTable').remove();
                        $('table.cityTable').remove();
                    }
                    if(previous.toLowerCase() == 'branch'){
                        $('div.branchTable').remove();
                        $('table.branchTable').remove();
                    }
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'bank code') that.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') that.mand_account_number = true;

                    that.generateButtonProccess();
                });
            },
            showFieldInIdentifiers(datafor,fileRowData,itemIndex){
                var dataTableFor = '';
                var mappingfor = '';
                if(datafor == 'department'){
                    mappingfor = '<h3>We\'ve found some new departments.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'departmentTable';
                }
                if(datafor == 'city'){
                    mappingfor = '<h3>We\'ve found some new cities.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'cityTable';
                }
                if(datafor == 'category'){
                    mappingfor = '<h3>We\'ve found some new categories.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'categoryTable';
                }
                if(datafor == 'branch'){
                    mappingfor = '<h3>We\'ve found some new branches.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'branchTable';
                }
                var html = mappingfor;
                if(datafor == 'department'){
                    var departmentArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var department = data[itemIndex];
                        if(departmentArray.indexOf(department) == -1){
                            departmentArray.push(department);
                        }
                    }
                    this.departmentCount = departmentArray.length;
                    for(var k = 0; k < this.departmentCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultDepartment = 'Select department';
                        for(var t=0; t < this.departmentLi.length; t++){
                            if(this.departmentLi[t].label.toLowerCase() == departmentArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultDepartment = this.departmentLi[t].label;
                                this.finalDepartmentArray.push({id:this.departmentLi[t].value,name:departmentArray[k]});
                                this.departmentMapped = this.finalDepartmentArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory department"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+this.departmentLi[t].value+'\',\''+departmentArray[k]+'\',this);">'+this.departmentLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+departmentArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown dept">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Department<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="department_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-department"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addDepartment"><i class="fas fa-plus"></i> Add Department</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'category'){
                    var categoryArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var category = data[itemIndex];
                        if(categoryArray.indexOf(category) == -1){
                            categoryArray.push(category);
                        }
                    }
                    this.categoryCount = categoryArray.length;
                    for(var k = 0; k < this.categoryCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCategory = 'Select Category';
                        for(var t=0; t < this.categoryLi.length; t++){
                            if(this.categoryLi[t].label.toLowerCase() == categoryArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCategory = this.categoryLi[t].label;
                                this.finalcategoryArray.push({id:this.categoryLi[t].value,name:categoryArray[k]});
                                this.categoryMapped = this.finalcategoryArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory category"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCategorySelection(\''+this.categoryLi[t].value+'\',\''+categoryArray[k]+'\',this);">'+this.categoryLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+categoryArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Category<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="category_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-category"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCategory"><i class="fas fa-plus"></i> Add Category</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'city'){
                    var cityArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var city = data[itemIndex];
                        if(cityArray.indexOf(city) == -1){
                            cityArray.push(city);
                        }
                    }
                    this.cityCount = cityArray.length;
                    for(var k = 0; k < this.cityCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCity = 'Select City';
                        for(var t=0; t < this.cityLi.length; t++){
                            if(this.cityLi[t].label.toLowerCase() == cityArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCity = this.cityLi[t].label;
                                this.finalcityArray.push({id:this.cityLi[t].value,name:cityArray[k]});
                                this.cityMapped = this.finalcityArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory city"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+this.cityLi[t].value+'\',\''+cityArray[k]+'\',this);">'+this.cityLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+cityArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select City<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="city_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-city"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCity"><i class="fas fa-plus"></i> Add City</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'branch'){
                    var branchArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var branch = data[itemIndex];
                        if(branchArray.indexOf(branch) == -1){
                            branchArray.push(branch);
                        }
                    }
                    this.branchCount = branchArray.length;
                    for(var k = 0; k < this.branchCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultBranch = 'Select Branch';
                        for(var t=0; t < this.branchLi.length; t++){
                            if(this.branchLi[t].label.toLowerCase() == branchArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultBranch = this.branchLi[t].label;
                                this.finalBranchArray.push({id:this.branchLi[t].value,name:branchArray[k]});
                                this.branchMapped = this.finalBranchArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory branch"><a class="dropdown-link" href="javascript:void(0)" onclick="mapBranchSelection(\''+this.branchLi[t].value+'\',\''+branchArray[k]+'\',this);">'+this.branchLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+branchArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Branch<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="branch_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-branch"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addBranch"><i class="fas fa-plus"></i> Add Branch</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                $('div.need-attention-content').append(html);
                this.customCombo();
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        // $('div#duplicatemessage').html() +
                        var error_message = duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
            saveDepartment(){
                var departmentValue = $('#departmentAddValue').val();
                if (departmentValue === "") {
                    that.showAlertBox('error','Please enter department name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.departmentForm.post('/api/addDepartment')
                    .then(response => {
                        if(response.status == 200){
                            that.finalDepartmentArray.push({id:response.data.data.id,name:departmentValue});
                            that.departmentMapped = that.finalDepartmentArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+response.data.data.id+'\',\''+departmentValue+'\',this);">'+departmentValue+'</a></li>';
                            $('ul.department_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addDepartment").modal("hide");
                            that.showToastBox('success','Department has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            },
            saveCategory(){
                var categoryValue = $('#categoryAddValue').val();
                if (categoryValue === "") {
                    that.showAlertBox('error','Please enter category name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.categoryForm.post('/api/addCategory')
                    .then(response => {
                        if(response.status == 200){
                            that.finalcategoryArray.push({id:response.data.data.id,name:categoryValue});
                            that.categoryMapped = that.finalcategoryArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCategorySelection(\''+response.data.data.id+'\',\''+categoryValue+'\',this);">'+categoryValue+'</a></li>';
                            $('ul.category_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addCategory").modal("hide");
                            that.showToastBox('success','Category has been added');
                            that.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            }
            ,
            saveCity(){
                var cityValue = $('#cityAddValue').val();
                if (cityValue === "") {
                    that.showAlertBox('error','Please enter city name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.cityForm.post('/api/addCity')
                    .then(response => {
                        if(response.status == 200){
                            that.finalcityArray.push({id:response.data.id,name:cityValue});
                            that.cityMapped = that.finalcityArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+response.data.data.id+'\',\''+cityValue+'\',this);">'+cityValue+'</a></li>';
                            $('ul.city_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addCategory").modal("hide");
                            that.showToastBox('success','City has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            },
            saveBranch(){
                var branchValue = $('#branchAddValue').val();
                if (branchValue === "") {
                    that.showAlertBox('error','Please enter branch name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.branchForm.post('/api/addBranch')
                    .then(response => {
                        if(response.status == 200){
                            that.finalBranchArray.push({id:response.data.data.id,name:branchValue});
                            that.branchMapped = that.finalBranchArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapBranchSelection(\''+response.data.data.id+'\',\''+branchValue+'\',this);">'+branchValue+'</a></li>';
                            $('ul.branch_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addBranch").modal("hide");
                            that.showToastBox('success','Branch has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            }

        },
        updated(){
            $("body").on("click" , ".dropdown-menu .vendorBulkUploadCategory a", function(e){
                e.preventDefault();
                $(this).parents('.dropdown').find('.drop-value-changer').html($(this).text());
            });
            var idCount = 1;
            $('.list').each(function() {
                $(this).attr('id', 'dropdown-menu' + idCount);
                idCount++;
            });
            $('.add-category .btn-primary').click(function(){
                var selectID = $(this).parent().siblings('.list').attr('id');
                var popupValue = $('#popu-value').val(selectID);
            })
        },
        created() {
        },
        mounted(){
            var that = this;
            this.initDropZone();
            $("#drop").dropzone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            this.getBulkUploadData();
            $(window.document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function() {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });



            window.mapDepartmentSelection = function(id,value,obj){
                // $(obj).parent().find("li").removeClass("row-enabled");
                // $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalDepartmentArray){
                    if(that.finalDepartmentArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalDepartmentArray.splice(index,1);
                        that.finalDepartmentArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalDepartmentArray.push({id:id,name:value});
                }
                that.departmentMapped = that.finalDepartmentArray.length;
                that.generateButtonProccess();
            }
            window.mapCategorySelection = function(id,value,obj){
                $(obj).parent().find("li").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalcategoryArray){
                    if(that.finalcategoryArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalcategoryArray.splice(index,1);
                        that.finalcategoryArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalcategoryArray.push({id:id,name:value});
                }
                that.categoryMapped = that.finalcategoryArray.length;
                that.generateButtonProccess();
            }
            window.mapCitySelection = function(id,value,obj){
                $(obj).parent().find("li").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalcityArray){
                    if(that.finalcityArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalcityArray.splice(index,1);
                        that.finalcityArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalcityArray.push({id:id,name:value});
                }
                that.cityMapped = that.finalcityArray.length;
                that.generateButtonProccess();
            }
            window.mapBranchSelection = function(id,value,obj){
                $(obj).parent().find("li.branch").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalBranchArray){
                    if(that.finalBranchArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalBranchArray.splice(index,1);
                        that.finalBranchArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalBranchArray.push({id:id,name:value});
                }
                that.branchMapped = that.finalBranchArray.length;
                that.generateButtonProccess();
            }
        }
    }
</script>
